module.exports = __webpack_public_path__ + "assets/img/product-community1.87677cdf.png";